import { useQuery, UseQueryResult } from 'react-query';

import {
    axiosInstance,
    getDynamicHeaders,
    reactCachedQueryOptions
} from '../../../../api';
import { DEMANDE_END_POINT } from '../../apiEndPoints';

export enum FrequenceRemboursement {
    HEBDOMADAIRE = 'HEBDOMADAIRE',
    AUX_DEUX_SEMAINES = 'AUX_DEUX_SEMAINES',
    MENSUELLE = 'MENSUELLE',
    HEBDOMADAIRE_ACCELEREE = 'HEBDOMADAIRE_ACCELEREE',
    AUX_DEUX_SEMAINES_ACCELEREE = 'AUX_DEUX_SEMAINES_ACCELEREE'
}

export enum TypeFumeur {
    OUI = 'OUI',
    NON = 'NON'
}

export enum CodeAssurance {
    VIE = 'V',
    VIE_INVALIDITE = 'I',
    SOUMISSION_ASSURANCE = 'S',
    AUCUNE = 'A',
    RETRAIT = 'R'
}

export enum TypeAssurance {
    AP_MAT = 'AP_MAT',
    AP = 'AP',
    NONE = 'NONE'
}

export enum TypePret {
    FIXE_FERME = 'FIXE_FERME',
    FIXE_OUVERT = 'FIXE_OUVERT',
    TAUX_REVISABLE_ANNUELLEMENT = 'TAUX_REVISABLE_ANNUELLEMENT',
    VARIABLE_REGULIER = 'VARIABLE_REGULIER',
    VARIABLE_REDUIT = 'VARIABLE_REDUIT',
    VARIABLE_PROTEGE = 'VARIABLE_PROTEGE'
}

export type IAmortissement = {
    annee: number;
    mois: number;
};

export interface IAssuree {
    prenom: string;
    nom: string;
    age: number;
    indicateurFumeur?: TypeFumeur;
    pctCouvertureAssuranceVie: number;
    pctCouvertureAssuranceInvalidite: number;
    indicateurEligibiliteAssuranceVie: boolean;
    indicateurEligibiliteAssuranceInvalidite: boolean;
}

export interface IPret {
    dureeTerme: number;
    typePret: TypePret;
    dateRappel: string;
    solde: number;
    frequenceRemboursement: FrequenceRemboursement;
    amortissement: IAmortissement;
    montantRemboursement: number;
    tauxInteret: number;
    listeAssures: Array<IAssuree>;
    indicateurReductionTauxNonFumeur: boolean;
    codeAssurance: CodeAssurance;
    typeAssurance: TypeAssurance;
}

export const END_POINT = DEMANDE_END_POINT + '/pret';

const fetch = async (idDemande: number) => {
    const endPoint = END_POINT.replace(/{idDemande}/g, String(idDemande));

    const { data } = await axiosInstance.get(
        endPoint,
        await getDynamicHeaders()
    );

    return data;
};

export function usePretApi(
    idDemande: number = undefined,
    isEnabled = true
): UseQueryResult<IPret, Error> {
    return useQuery<IPret, Error>(['pret', idDemande], () => fetch(idDemande), {
        ...reactCachedQueryOptions(),
        enabled: !!isEnabled
    });
}
